import { render, staticRenderFns } from "./shuju.vue?vue&type=template&id=340332e2&scoped=true"
import script from "./shuju.vue?vue&type=script&lang=js"
export * from "./shuju.vue?vue&type=script&lang=js"
import style0 from "./shuju.vue?vue&type=style&index=0&id=340332e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340332e2",
  null
  
)

export default component.exports